var map = {
	"./mul_no.png": "14a8",
	"./mul_yes.png": "195f",
	"./stu_avatar_1.jpg": "804a",
	"./stu_avatar_10.jpg": "8b5e",
	"./stu_avatar_11.jpg": "55d0",
	"./stu_avatar_2.jpg": "f944",
	"./stu_avatar_3.jpg": "31cc",
	"./stu_avatar_4.jpg": "25ec",
	"./stu_avatar_5.jpg": "ed8c",
	"./stu_avatar_6.jpg": "f4b0",
	"./stu_avatar_7.jpg": "479e",
	"./stu_avatar_8.jpg": "0e52",
	"./stu_avatar_9.jpg": "3ff7",
	"./stu_avatar_class.jpg": "9c3d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6601";